import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '@/services/auth-service';

export const OAuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const handleCallback = async () => {
            try {
                const code = searchParams.get('code');
                const state = searchParams.get('state');

                if (!code || !state) {
                    throw new Error('Missing OAuth parameters');
                }
                await authService.handleOAuthCallback(code, state);
                navigate('/library');
            } catch (error) {
                console.error('OAuth callback error:', error);
                navigate('/signin', {
                    state: { error: 'Failed to authenticate with Google' }
                });
            }
        };

        handleCallback();
    }, [searchParams, navigate]);

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="w-8 h-8 border-t-2 border-b-2 rounded-full animate-spin border-primary"></div>
        </div>
    );
};

export default OAuthCallback;
